<template>
  <div>
    <slot
      name="activator"
      v-bind="{ importAction, exportAction, isExportProcessing }"
    />
    <Import
      :show-import-dialog="showImportDialog"
      @cancel="showImportDialog = false"
    />

    <ExportDialog
      v-model="showExportDialog"
      @export="handleExport"
    />
  </div>
</template>

<script lang="ts" setup>
import * as Sentry from '@sentry/vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { exportLeads, ExportTooLargeError } from '@/lib/export'
import { showSnackbarMessage } from '@/lib/snackbarMessages'
import Import from '@/modules/leads/Import.vue'

import type { ExportType } from './ExportDialog.vue'
import ExportDialog from './ExportDialog.vue'

type Props = {
  provider: string
}

defineProps<Props>()

const { t } = useI18n()

const showImportDialog = ref(false)
const showExportDialog = ref(false)
const isExportProcessing = ref(false)

const importAction = () => {
  showImportDialog.value = true
}

const exportAction = () => {
  showExportDialog.value = true
}

const handleExport = async (exportType: ExportType) => {
  try {
    isExportProcessing.value = true
    await exportLeads({
      sortBy: undefined,
      sortDesc: undefined,
      search: undefined,
      filters: undefined,
      onlyNotExported: exportType === 'non-exported',
    })
  } catch (error) {
    Sentry.captureException(error)
    if (error instanceof ExportTooLargeError) {
      showSnackbarMessage('error', t('alerts.export.too-large'))
    } else {
      showSnackbarMessage('error', t('alerts.export.error'))
    }
  } finally {
    isExportProcessing.value = false
  }
}
</script>
